import {createStyles} from '@mantine/core';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';

const useStyles = createStyles(() => ({
  sticky: {
    position: 'sticky',
    bottom: 0,
    margin: '16px -16px -16px',
    padding: '16px 0px !important',
    backgroundColor: 'white',
  },
  buttons: {
    marginRight: '20px',
  },
}));

export interface ModalFooterProps {
  /* Used for any arbitrary content to display in the footer */
  children?: React.ReactNode;
  /* Custom styles to apply to the footer container */
  className?: string;
  /* Whether to apply the default modal styling to make the footer sticky */
  sticky?: boolean;
  /* Used for the buttons to display in the footer */
  buttons?: React.ReactNode;
  /* Custom styles to apply to the buttons container */
  contentClassName?: string;
  /* Custom styles to apply to the footer contents (non-button area) */
  buttonsClassName?: string;
}

export default function ModalFooter({
  children,
  className,
  sticky = true,
  buttons,
  buttonsClassName,
  contentClassName = 'u-spacing-right',
}: ModalFooterProps): JSX.Element {
  const {classes, cx} = useStyles();
  return (
    <div
      className={cx('modal-footer', className, sticky && classes.sticky)}
      {...getTestProps({component: 'Modal', element: 'footer'})}
    >
      <span className={contentClassName}>{children}</span>
      {buttons && <span className={cx(classes.buttons, buttonsClassName)}>{buttons}</span>}
    </div>
  );
}
